<template>
  <div class="umbforms-multiple-upload">
    <input
      :id="id"
      ref="input"
      type="file"
      :name="name"
      :data-umb="id"
      multiple
      :data-val="validationMessage ? 'true' : null"
      :data-val-required="validationMessage || null"
      :aria-describedby="tooltip ? `${id}_description` : null"
      @change="addFiles"
    />

    <div
      v-if="restoredFiles.length || fileList.length"
      class="fileupload-files"
    >
      <h5 v-if="restoredFiles.length" class="fileupload-files__title">
        {{ existingFilesLabel }}
      </h5>
      <ul :id="`${id}_selectedFiles`" class="fileupload-files__list">
        <li v-for="file in fileList" :key="file.key">
          <span>{{ file.name }}</span>
          <button
              v-if="file.source === 'selected'"
              type="button"
              class="btn-remove-file"
              aria-label="Verwijder"
              @click="removeFile(file)"
            >
              <span class="sr-only">Verwijder</span>
           </button>
        </li>
      </ul>
    </div>

    <template v-for="file in restoredFiles" :key="file.filePath">
      <input
        type="hidden"
        :name="`${name}_file_${file.fileName}`"
        :value="file.filePath"
      />
    </template>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  id: { type: String, required: true },
  name: { type: String, required: true },
  tooltip: { type: String, default: '' },
  validationMessage: { type: String, default: '' },
  existingFilesLabel: { type: String, default: 'Huidig(e) bestand(en)' },
  existingFiles: { type: Array, default: () => [] },
});

const input = ref(null);
const selectedFiles = ref([]);
const restoredFiles = ref([...props.existingFiles]);
const fileList = computed(() => [
  ...selectedFiles.value.map((file) => ({
    key: fileKey(file),
    name: file.name,
    source: 'selected',
  })),
  ...restoredFiles.value.map((file) => ({
    key: file.filePath,
    name: file.fileName,
    source: 'existing',
  })),
]);

const fileKey = (file) => `${file.name}-${file.size}-${file.lastModified}`;

const syncInputFiles = async () => {
  if (!input.value || typeof DataTransfer === 'undefined') {
    return;
  }

  const dataTransfer = new DataTransfer();
  selectedFiles.value.forEach((file) => dataTransfer.items.add(file));
  input.value.files = dataTransfer.files;
};

const addFiles = async () => {
  const newFiles = Array.from(input.value?.files || []);

  if (!newFiles.length) {
    return;
  }

  restoredFiles.value = [];
  selectedFiles.value = [...selectedFiles.value, ...newFiles].filter(
    (file, index, files) =>
      files.findIndex((candidate) => fileKey(candidate) === fileKey(file)) ===
      index
  );
  await syncInputFiles();
};

const removeFile = async (file) => {
  if (file.source !== 'selected') {
    return;
  }

  selectedFiles.value = selectedFiles.value.filter(
    (selectedFile) => fileKey(selectedFile) !== file.key
  );
  await syncInputFiles();
};
</script>
